import { Link } from 'react-router-dom';
import { AlertTriangle, Clock, ShoppingCart, ChevronLeft } from 'lucide-react';

export default function AlertsPanel({ overdueCount = 0, pendingOrders = 0 }) {
  const alerts = [
    overdueCount > 0 && {
      icon: AlertTriangle,
      color: 'text-red-500',
      bg: 'bg-red-50 border-red-100',
      label: `${overdueCount} فاتورة متأخرة السداد`,
      link: '/collections',
    },
    pendingOrders > 0 && {
      icon: Clock,
      color: 'text-amber-500',
      bg: 'bg-amber-50 border-amber-100',
      label: `${pendingOrders} طلب معلق بانتظار التأكيد`,
      link: '/orders',
    },
  ].filter(Boolean);

  if (alerts.length === 0) return null;

  return (
    <div className="space-y-2">
      {alerts.map((a, i) => (
        <Link key={i} to={a.link}>
          <div className={`flex items-center gap-3 p-3 rounded-xl border ${a.bg} hover:opacity-80 transition-opacity`}>
            <a.icon className={`w-4 h-4 ${a.color} flex-shrink-0`} />
            <span className="text-sm font-medium text-foreground flex-1">{a.label}</span>
            <ChevronLeft className="w-4 h-4 text-muted-foreground" />
          </div>
        </Link>
      ))}
    </div>
  );
}